<template>
  <div class="search-field">
    <input
      type="text"
      :value="value"
      placeholder=" "
      class="search-field__input"
      :class="{ 'search-field__input-active': value}"
      @input="onInput($event.target.value)"
      @keypress.enter.prevent="checkEnter"
    >
    <label class="search-field__label">
      {{ label }}
      <span v-if="required" class="input__label-required">*</span>
    </label>
    <div
      v-if="value"
      class="search-field__container-close"
      @click="clearSearch"
    >
      <CloseMap />
    </div>
  </div>
</template>
<script>
  import CloseMap from '@/assets/img/icons/closeMap.svg?inline'

  export default {
    name: 'SearchField',

    components: {
      CloseMap
    },

    props: {
      disabled: Boolean,
      value: {
        type: String,
        default: ''
      },
      label: String,
      required: Boolean
    },

    methods: {
      clearSearch () {
        this.$emit('input', '')
        this.$emit('clickClearIcon')
      },
      clickSearchIcon () {
        this.$emit('clickSearchIcon')
      },
      checkEnter () {
        if (this.value.length) {
          this.$emit('clickSearchIcon')
        } else {
          this.$emit('clickClearIcon')
        }
      },
      onInput (value) {
        this.$emit('input', value)
        if (value.length === 0) {
          this.$emit('clickClearIcon')
        }
      }
    }
  }
</script>
<style lang="scss">
.search-field {
  position: relative;
  display: flex;

  &__container-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    align-self: center;
    cursor: pointer;
  }

  &__label {
    pointer-events: none;
    position: absolute;
    top: 19px;
    left: 20px;
    z-index: 1;
    display: inline-block;
    padding-bottom: 1em;
    font-size: 16px;
    color: $c-gray-new;
    user-select: none;
    transition: all 0.2s;

    &-top {
      top: 6px;
      font-size: 10px;
      line-height: 20px;
      color: $c-gray;
    }

    &-required {
      color: $c-active-light;
    }
  }

  &__input {
    display: block;
    width: 100%;
    height: 56px;
    padding: 20px 40px 10px 20px;
    font-family: NobelWGL-Book;
    font-weight: 400;
    font-style: Book;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 1px;
    border-radius: 0;
    border: 1px solid $c-gray-light;
    outline: none;
    caret-color: $c-black;
    appearance: none;
    transition: 0.3s;

    @include hover {
      background-color: $gray;
    }

    &:focus, &:not(:placeholder-shown) + .label, &-active {
      background-color: $c-white;
      border-color: $c-gray-new;

      + .search-field__label {
        top: 6px;
        font-size: 10px;
        line-height: 20px;
        color: $c-gray;
      }
    }
  }

  .icon {
    position: absolute;
    top: 50%;
    left: 25px;
    padding-right: 0;
    font-size: 20px;
    line-height: 45px;
    color: $c-black;
    cursor: pointer;
    transform: translateY(-50%);
  }
}
</style>
